import React, { useState } from 'react';
import DashboardStats from './DashboardStats';
import AuditList from './AuditList';
import AuditFilters from './AuditFilters';

const AIInsightsDashboard = () => {
    require('./ai-insights.css');
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);

    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    return (
        <>
            <div className="row page-titles mx-0">
                <div className="col-sm-6 p-md-0">
                    <div className="welcome-text">
                        <h4>AI Insights Audit & Analytics</h4>
                        <p className="mb-0">Track AI usage, performance, and issues.</p>
                    </div>
                </div>
            </div>  

            <div className="container-fluid">
                {/* 1. Summary Stats (Top) */}
                <DashboardStats filters={filters} />
                <br></br>

                {/* 2. Filters (Middle) */}
                <AuditFilters onApply={setFilters} loading={loading} />

                {/* 3. List (Bottom) */}
                <AuditList filters={filters} onLoadingChange={handleLoadingChange} />
            </div> 
        </>
    );
};
 
export default AIInsightsDashboard;